import { create } from "zustand";

/**
 * Employee/intern multi-step form draft store.
 * Full employee-management module was removed from the platform template;
 * this keeps layout imports compiling and avoids runtime crashes on no-ops.
 */
const useEmployeeDataStore = create((set) => ({
  data: null,
  Employee: null,
  Education: [],
  Address: [],
  Contact: [],
  DropDownData: {},
  EmployeeErrors: {},
  EducationErrors: {},
  AddressErrors: {},
  ContactErrors: {},

  setData: (data) => set({ data }),
  setEmployee: (Employee) => set({ Employee }),
  setEducation: (Education) => set({ Education }),
  setAddress: (Address) => set({ Address }),
  setContact: (Contact) => set({ Contact }),
  setEmployeeErrors: (EmployeeErrors) => set({ EmployeeErrors }),
  setEducationErrors: (EducationErrors) => set({ EducationErrors }),
  setAddressErrors: (AddressErrors) => set({ AddressErrors }),
  setContactErrors: (ContactErrors) => set({ ContactErrors }),
  setDropDownData: (DropDownData) => set({ DropDownData }),

  getDropdowndata: async () => {
    // No-op stub — employee dropdown APIs not present in this template.
    return {};
  },

  resetData: () =>
    set({
      data: null,
      Employee: null,
      Education: [],
      Address: [],
      Contact: [],
      DropDownData: {},
      EmployeeErrors: {},
      EducationErrors: {},
      AddressErrors: {},
      ContactErrors: {},
    }),
}));

export default useEmployeeDataStore;
